export const formatDate = (date: string): string => {
  const dt = new Date(date);
  const displayDate = new Intl.DateTimeFormat("en-US", {
    month: "long",
    day: "numeric",
    year: "numeric"
  }).format(dt);

  return displayDate;
};

export const videoRunTime = (seconds: number): string => {
  let time = "";
  const minutes = Math.floor(seconds / 60);
  const hours = Math.floor(minutes / 60);

  if (hours) {
    time = `${hours} hr`;
  }

  if (minutes) {
    time = time + `${minutes} min`;
  }
  if (!time) {
    return "1 min";
  }
  return time;
};
